import { Avatar, CHARACTER_TYPE, Paginated, ShallowCourse } from "@vixi/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api, { allCoursesQueryOptions, endpoints } from "@vixi/api";
import { allAvatarsCountQueryOptions } from "@/queries/avatars/allAvatarsCountQuery";

export const useSaveAvatar = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (avatar: Avatar) => {
      // make sure you have the latest course
      const latestCourse = await queryClient
        .ensureQueryData<Paginated<ShallowCourse>>(
          allCoursesQueryOptions({
            pageNumber: 1,
            pageSize: 1,
          }),
        )
        .then((data) => data.items?.[0]);

      if (!latestCourse) {
        throw new Error("No course found to save the avatar to.");
      }

      const response = await api.post<boolean>(endpoints.saveAvatar, {
        courseId: latestCourse.id,
        character: {
          url: avatar.url,
          characterType: CHARACTER_TYPE.COURSE_CHARACTER,
        },
      });

      return response.data;
    },
    onSuccess: () => {
      // Invalidate avatars count query after saving avatar
      queryClient.invalidateQueries({
        queryKey: allAvatarsCountQueryOptions().queryKey,
      });
    },
  });
};
